import { render, staticRenderFns } from "./SolicitacaoCartaResposta.vue?vue&type=template&id=effbd246&scoped=true"
import script from "./SolicitacaoCartaResposta.vue?vue&type=script&lang=js"
export * from "./SolicitacaoCartaResposta.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoCartaResposta.vue?vue&type=style&index=0&id=effbd246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effbd246",
  null
  
)

export default component.exports